import { useCallback } from "react";

import { useTypedQuery } from "hooks";
import { TyreGroupQueryKeys } from "modules/AppointmentDetails/components/VehicleTyres/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Tyre, VehicleTyreReplacement } from "models";

const selectTyreNetStock = (tyre_replacements: VehicleTyreReplacement[], stockTyres: Tyre[]) => {
  const stockTyresWithId: Tyre[] = [];

  stockTyres.forEach(st => {
    const replacement = tyre_replacements.find(tr => tr.tyre?.ean === st.ean);

    if (replacement?.tyre) {
      st.id = replacement.tyre.id;
      stockTyresWithId.push(st);
    }
  });

  return stockTyresWithId;
};

export const useTyreNetStock = (isTyreNetEnabled: boolean, tyre_replacements: VehicleTyreReplacement[]) => {
  const query = useTypedQuery({
    queryKey: TyreGroupQueryKeys.tyreNetStock(tyre_replacements.map(tr => tr.id)),
    queryFn: async ({ baseUrl, endpoint, params }) => (tyre_replacements.length > 0 ? (await ApiInstance.post(endpoint, params, baseUrl)).data.tyres : []),
    enabled: isTyreNetEnabled,
    select: useCallback((stockTyres: Tyre[]) => selectTyreNetStock(tyre_replacements, stockTyres), [tyre_replacements])
  });

  return {
    data: query.data,
    isFetching: query.isFetching
  };
};
